import { ItemKind } from '../../constants/ItemKind';
import { NextCallData } from '../../utils/NextCallData';
import { UnsplashSourceName } from './constants';
import { toError } from './parsers/error';
import { parseFolderId } from './parsers/folder-id';
import { parseItems } from './parsers/items';
export function initItems(settings, http) {
  const nextCallData = new NextCallData();
  function requestItems(folderId, options, query) {
    if (query === void 0) {
      query = null;
    }
    options = options || {};
    options.paging = options.paging || {};
    options.sort = options.sort || {};
    if (nextCallData.isNextCallDataExists(options.paging, query, folderId)) {
      return nextCallData.getPromiseAndReset();
    }
    const {
      category
    } = parseFolderId(folderId);
    const limit = options.paging.size || settings.itemsLimit;
    const requestOptions = {
      limit,
      offset: options.paging.cursor || 0,
      ...(category && category !== 'all' ? {
        category
      } : {})
    };
    if (settings.language) {
      requestOptions.lang = settings.language;
    }
    if (query !== null) {
      requestOptions.query = query;
    }
    const url = `${settings.apiUrl}/_api/media-unsplash-service-server/v1/unsplash/photos${query ? '/search' : ''}`;
    const requestPromise = http.get(url, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseItems).catch(toError);
    return requestPromise;
  }
  function importToSite(itemId) {
    const url = `${settings.apiUrl}/_api/media-unsplash-service-server/v1/unsplash/photos/${itemId}/import`;
    const requestOptions = {
      withCredentials: true
    };
    return http.post(url, null, null, requestOptions).then(response => {
      const {
        data: {
          photoInfo
        }
      } = response;
      return {
        ...photoInfo,
        id: photoInfo.fileName,
        kind: ItemKind.File,
        source: UnsplashSourceName,
        name: ''
      };
    });
  }
  function list(folderId, options) {
    const itemsPromise = requestItems(folderId, options, null);
    if (settings.prefetchNextPage) {
      itemsPromise.then(response => {
        if (!response.paging.cursor) {
          return;
        }
        nextCallData.set(response.paging, requestItems(folderId, {
          ...options,
          paging: response.paging
        }, null), null, folderId);
      });
    }
    return itemsPromise;
  }
  function search(folderId, query, options) {
    const itemsPromise = requestItems(folderId, options, query);
    if (settings.prefetchNextPage) {
      itemsPromise.then(response => {
        if (!response.paging.cursor) {
          return;
        }
        nextCallData.set(response.paging, requestItems(folderId, {
          ...options,
          paging: response.paging
        }, query), query, folderId);
      });
    }
    return itemsPromise;
  }
  return {
    list,
    search,
    importToSite
  };
}